export const getDiscoveryUserRoute = () => 'buzzAppCentral/discoveryAppUser';
export const employeeRoute = () => 'auth/identity/bccUser/signup';
export const schoolRoute = () => 'teenybeans/schools';
export const userRoute = () => 'teenybeans/user';
export const usersRoute = () => 'teenybeans/users';
export const schoolDetailsRoute = (id) => `teenybeans/schools/${id}`;
export const updateSchoolRoute = (id) => `teenybeans/schools/${id}`;
export const updateSchoolAgreementRoute = (id) =>
  `teenybeans/schools/${id}/agreement_documents`;
export const deleteSchoolAgreementRoute = (payload) =>
  `teenybeans/schools/${payload.schoolId}/agreement_documents/${payload.agreement}`;
export const updateSchoolDigitalDeliverableRoute = (id) =>
  `teenybeans/schools/${id}/digital_deliverables`;
export const adminDigitalDeliverableRoute = (payload) =>
  `teenybeans/schools/${payload.schoolId}/digital_deliverables/${payload.digital}/admin_feedback`;
export const updateSchoolDocRoute = (id) =>
  `teenybeans/schools/${id}/school_documents`;
export const deleteSchoolDocRoute = (payload) =>
  `teenybeans/schools/${payload.schoolId}/school_documents/${payload.doc}`;
export const deleteDigitalDocRoute = (payload) =>
  `teenybeans/schools/${payload.schoolId}/digital_deliverables/${payload.doc}`;
